import React, { useId } from 'react';
import { MdCloudUpload } from 'react-icons/md';

export default function DocumentUpload({
  id,
  value,
  onChange,
  label = 'Document',
  accept = '.pdf,.doc,.docx,.png,.jpg,.jpeg',
  title = 'Drop documents here',
}) {
  const generatedId = useId();
  const inputId = id || `document-upload-${generatedId}`;

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0] ?? null;
    if (file) onChange(file);
  };

  const handleFileSelect = (event) => {
    const file = event.currentTarget.files?.[0] ?? null;
    onChange(file);
  };

  const fileName = value
    ? value.file_name || value.fileName || value.name || value.documentName || value.document_name ||
      (value.file && (value.file.name || value.file.fileName || value.file.file_name)) ||
      (typeof value === 'string' ? value : String(value))
    : '';

  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">{label}</label>
      <div
        className="d-flex flex-column align-items-center justify-content-center rounded-4 border border-dashed border-secondary p-5 text-center cursor-pointer"
        style={{ minHeight: 180 }}
        onClick={() => document.getElementById(inputId)?.click()}
        onDragOver={(event) => event.preventDefault()}
        onDrop={handleDrop}
      >
        <MdCloudUpload size={36} className="text-secondary mb-3" />
        <p className="fw-semibold mb-1">{title}</p>
        <p className="text-secondary small mb-2">
          or <span className="text-primary">Click here to browse</span>
        </p>
        {fileName ? (
          <div className="small text-secondary mt-2">{fileName}</div>
        ) : null}
      </div>
      <input
        id={inputId}
        type="file"
        accept={accept}
        className="d-none"
        onChange={handleFileSelect}
      />
    </div>
  );
}
